"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { visuallyHidden } from "@mui/utils";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { SpaceXs, SpaceMd, SizeBorderWidthThin, ColorGray500, SpaceSm, SpaceXl } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const WarehouseTileSkeleton = () => {
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      sx: {
        borderBottom: `${SizeBorderWidthThin} solid ${ColorGray500}`,
        display: "flex",
        flexDirection: "column",
        padding: SpaceMd,
        rowGap: SpaceXs
      },
      "data-testid": "warehousetile_skeleton",
      children: [
        /* @__PURE__ */ jsx(CostcoBox, { sx: visuallyHidden, children: "Loading" }),
        /* @__PURE__ */ jsxs(
          CostcoBox,
          {
            sx: {
              alignItems: "center",
              display: "flex",
              gap: SpaceSm
            },
            "data-testid": "skeleton_content_1",
            children: [
              /* @__PURE__ */ jsx(
                Skeleton,
                {
                  "data-testid": "skeleton_locationicon",
                  height: 20,
                  hiddenText: "",
                  variant: "circular",
                  width: 20
                }
              ),
              /* @__PURE__ */ jsx(
                Skeleton,
                {
                  "data-testid": "skeleton_nameanddistance",
                  hiddenText: "",
                  variant: "textHeader",
                  width: 220
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              alignItems: "flex-start",
              display: "flex",
              flexdirection: "column",
              paddingLeft: SpaceXl
            },
            "data-testid": "skeleton_content_2",
            children: /* @__PURE__ */ jsx(
              Skeleton,
              {
                "data-testid": "skeleton_stockstatus",
                hiddenText: "",
                variant: "textHeader",
                width: 170
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              alignItems: "flex-start",
              display: "flex",
              flexdirection: "column",
              paddingLeft: SpaceXl
            },
            "data-testid": "skeleton_content_3",
            children: /* @__PURE__ */ jsx(
              Skeleton,
              {
                "data-testid": "skeleton_openinghours",
                hiddenText: "",
                variant: "textHeader",
                width: 120
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          CostcoBox,
          {
            sx: {
              alignItems: "flex-start",
              display: "flex",
              flexdirection: "column",
              gap: SpaceXs,
              paddingLeft: SpaceXl
            },
            "data-testid": "skeleton_content_4",
            children: [
              /* @__PURE__ */ jsx(
                Skeleton,
                {
                  "data-testid": "skeleton_seewarehousedetails",
                  hiddenText: "",
                  variant: "textHeader",
                  width: 155
                }
              ),
              /* @__PURE__ */ jsx(
                Skeleton,
                {
                  "data-testid": "skeleton_acccordionicon",
                  height: 24,
                  hiddenText: "",
                  variant: "rectangular",
                  width: 20
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          CostcoBox,
          {
            sx: {
              alignItems: "flex-start",
              display: "flex",
              flexdirection: "column",
              paddingLeft: SpaceXl,
              paddingTop: SpaceXs
            },
            "data-testid": "skeleton_content_5",
            children: /* @__PURE__ */ jsx(
              Skeleton,
              {
                "data-testid": "skeleton_button",
                height: 40,
                hiddenText: "",
                variant: "button",
                width: 236
              }
            )
          }
        )
      ]
    }
  );
};
export {
  WarehouseTileSkeleton
};
